import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type SubjectAboutsFetchedPayload = LabeledValuePayload[];

export type SubjectAboutsFetchedAction = {
	type: 'SUBJECT_ABOUTS_FETCHED';
	payload: SubjectAboutsFetchedPayload;
};

export default (payload: SubjectAboutsFetchedPayload): SubjectAboutsFetchedAction => ({
	type: 'SUBJECT_ABOUTS_FETCHED',
	payload,
});
